import PersonalAccountFormStore from "@/modules/personal/stores/account/personal_account_form.store,js";

export default {
  modules: { PersonalAccountFormStore },
};
